import { sortInOrder } from "@/lib/utils/sortInOrder";
import { RBACOrgRole, RBACProjectRole } from "@/types/role_based_access_control";


const projectRoleOrder: RBACProjectRole[] = [
    'project_manager',
    'project_member'
]
export const sortInProjectRoleOrder = sortInOrder<string|undefined>(projectRoleOrder)

const orgRoleOrder: RBACOrgRole[] = [
    'organization_owner',
    'organization_member'
]

export const sortInOrgRoleOrder = sortInOrder<string|undefined>(orgRoleOrder)